import React, { useState, useEffect, useRef } from "react";
import { Redirect } from "react-router";
import {
  BrowserRouter,
  Route,
  Switch,
  Link,
  useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import { lighten, makeStyles } from "@material-ui/core/styles";
import EventIcon from "@material-ui/icons/Event";
import logo3 from "../Assets/Logo3.png";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TablePagination from "@material-ui/core/TablePagination";
import { useQuery } from "react-query";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import Button from "@material-ui/core/Button";
import TableRow from "@material-ui/core/TableRow";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Colors from "./../Global/colors";
import LightButton from "../Global/LightButton";
import MiddleHeader from "../views/middleHeader/middleHeader";
import DarkButton from "../Global/DarkButton";
import moment from "moment";
import Modal from "@material-ui/core/Modal";
import GlobalApi from "./../Global";
import refresh_token from "./../Global/refresh_token";
import Sidebar from "./templateTools/tem-sidebar";
import swal from "@sweetalert/with-react";
import { Chart as GoogleChart } from "react-google-charts";
import Spinner from "./../Global/Spinner2";
import "./main.css";
import Drawer from "@material-ui/core/Drawer";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import Chart from "react-apexcharts";
import teamG from "../Assets/TeamG.png";
import siteG from "../Assets/siteG.png";
import chat from "../Assets/chat.png";
import companyG from "../Assets/package.png";
import pencil from "../Assets/pencil.png";
import NoRecords from "./../Global/NoRecords";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";

import {
  forReviewApprovals,
  forReviewActions,
} from "../Redux/Actions/routeTrackingAction";

//Images
import placeholder from "../Assets/placeholder.jpg";
import planH from "../Assets/planH.png";
import planN from "../Assets/planN.png";
import uploadN from "../Assets/uploadN.png";
import uploadH from "../Assets/uploadH.png";
import startN from "../Assets/startN.png";
import startH from "../Assets/startH.png";
import dots from "../Assets/dots.png";
import refresh from "../Assets/refresh.png";
import loading from "../Assets/loading.gif";
import daily_inspection from "../Assets/daily_inspection.png";
import due_inspection from "../Assets/due_inspection.png";
import failed_inspection from "../Assets/failed_inspection.png";
import overdue_inspection from "../Assets/overdue_inspection.png";
import review from "../Assets/review.png";
import rejected from "../Assets/rejected.png";
import missed from "../Assets/Missed_inspection.png";
import assigned from "../Assets/assign_action_plan.png";
import daily_inspection_white from "../Assets/daily_inspection_white.png";
import due_inspection_white from "../Assets/due_inspection_white.png";
import failed_inspection_white from "../Assets/failed_inspection_white.png";
import overdue_inspection_white from "../Assets/overdue_inspection_white.png";
import review_white from "../Assets/review_white.png";
import rejected_white from "../Assets/rejected_white.png";
import missed_white from "../Assets/Missed_inspection_white.png";
import assigned_white from "../Assets/assign_action_plan_white.png";

import { addIndustry } from "../Redux/Actions/industryAction";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
        }
      : {
          color: theme.palette.text.primary,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  return "";
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 550,
  },
  container: {
    maxHeight: "275px",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function Main(props) {
  let userData = useSelector((state) => state.userReducer.user);
  let industryId = useSelector((state) => state.industryReducer.industry);
  const language = useSelector((state) => state.languageReducer.language);
  let { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const [templates, setTemplates] = useState([]);
  const [dailyInspectionCount, setDailyInspectionCount] = useState(0);
  const [pendingInspectionCount, setPendingInspectionCount] = useState(0);
  const [overdueIns, setOverdueIns] = useState(0);
  const [failedIns, setFailedIns] = useState(0);
  const [openOnb, setOpenOnb] = React.useState(false);
  const [recentIns, setRecentIns] = useState(0);
  const [reviewIns, setReviewIns] = useState(0);
  const [missedIns, setMissedIns] = useState(0);
  const [assignedAction, setAssignedAction] = useState(0);
  const [permissions_obj, setPermissionObj] = useState({});
  const [reload1, setReload1] = useState(false);
  const [industries, setIndustries] = useState(
    useSelector((state) => state.industryArrReducer.industry)
  );
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [templateLoader, setTemplateLoader] = useState(true);
  const [token, setToken] = useState(
    useSelector((state) => state.userReducer.user.token)
  );
  const [currentIndustry, setCurrentIndustry] = useState(
    useSelector((state) => state.industryReducer.industry)
  );
  const [packageDetails, setPackageDetails] = useState(null);
  const [extraSideBarOpen, setExtraSideBarOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [opened, setOpened] = useState(null);
  console.log("location", location?.state);

  let company = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      getSchedules();
      getPermissions();
      getPendingInspections();
      fetchOverdueInspections();
      fetchFailedInspections();
    },
    [company?.id]
  );

  React.useEffect(() => {
    return () => {
      dispatch(forReviewApprovals(false));
      dispatch(forReviewActions(false));
    };
  }, []);

  React.useEffect(
    () => {
      console.log("STATERRRRR", location);
      if (location?.state?.onBoarding) {
        handleOpenOnb();
      }
      return () => {
        window.history.replaceState({}, document.title);
      };
    },
    [location]
  );

  const handleOpenOnb = () => {
    setOpenOnb(true);
  };

  const handleCloseOnb = () => {
    setOpenOnb(false);
    window.history.replaceState({}, document.title);
  };

  const handleScroll1 = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10;
    if (bottom) {
      if (templates.length < totalTemplates) {
        getMoreIndustriesTemplates();
      }
    }
  };

  const reload = () => {
    setReload1(!reload1);
  };
  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };
  function getSchedules() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    fetch(
      GlobalApi +
        "/ScheduleAssignee/get_schedule_daily?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setDailyInspectionCount(response.data.length);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getSchedules();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }
  function getPendingInspections() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let site_obj = {};
    fetch(
      GlobalApi +
        "/Inspection/get_pending_inspections?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setPendingInspectionCount(response.data.length);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPendingInspections();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }
  async function fetchOverdueInspections() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      company_id: company?.id,
      count_f: true,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/over_due_inspections?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(
          "Response Over Due Inspections :::::::::::::::::::::::::::::::::::::::::::::::::::::::>>>>>>",
          response
        );
        if (response.status === "Success") {
          //  console.log('Response Over Due Inspections >>>>>>', response)
          setOverdueIns(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  }
  async function fetchFailedInspections() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      company_id: company?.id,
      count_f: true,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Inspection/failed_inspections?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(
          "Response Rejected Inspections :::::::::::::::::::::::::::::::::::::::::::::::::::::: >>>>>>",
          response
        );
        if (response.status === "Success") {
          setFailedIns(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  }

  const history = useHistory();

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");

    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    let reqJson = await req.json();
    console.log("Calling Get License ", reqJson);

    if (
      reqJson?.package?.license?.status === "expired" ||
      reqJson?.package?.license?.status === "deactive"
    ) {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  const setTemplateArr = (data) => {
    setTemplates(data);
  };

  function getIndustriesTemplates(industry_Id) {
    setTemplateLoader(true);
    console.log("get industries function called>>>>>>>>>>");
    let data = localStorage.getItem("UserData");
    let JsonData = JSON.parse(data);
    let params = {
      skip: 0,
      limit: 12,
      industry_id: industry_Id ? industry_Id : industryId,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi + "/Template/get_all_public_templates_industries?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + JsonData.token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response from get all pubnlic >>>>>>>>>>", response);
        if (response.status === "Success") {
          setTotalTemplates(response.total_records);
          console.log("templates >>>>>>>>>>>>>>>>", response);
          setTemplateArr(response.data);
          setTemplateLoader(false);
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getMoreIndustriesTemplates() {
    console.log("get industries function called>>>>>>>>>>");
    let data = localStorage.getItem("UserData");
    let JsonData = JSON.parse(data);
    let params = { skip: templates.length, limit: 12, industry_id: industryId };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi + "/Template/get_all_public_templates_industries?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + JsonData.token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then((response) => {
        console.log("response from get all pubnlic >>>>>>>>>>", response);
        if (response.status === "Success") {
          setTotalTemplates(response.total_records);
          console.log("templates >>>>>>>>>>>>>>>>", response);
          setTemplateArr([...templates, ...response.data]);
          setTemplateLoader(false);
        }
      })
      .catch((error) => console.log(error.message));
  }

  useEffect(
    () => {
      getIndustriesTemplates();
    },
    [industryId]
  );

  useEffect(() => {
    getPackageDetails();
  }, []);

  const changeIndustry = (e) => {
    document.getElementById("scrollSection1").scrollTo(0, 0);
    console.log("Industry Value", e.target.value);
    setCurrentIndustry(e.target.value);
    dispatch(addIndustry(e.target.value));
    getIndustriesTemplates(e.target.value);
  };

  return (
    <div
      style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
    >
      <MiddleHeader />
      <div
        className="scrollHidden"
        style={{
          overflow: "hidden",
          display: "flex",
          // backgroundColor: "green",
          padding: "0px",
        }}
      >
        <div
          className=""
          style={{
            backgroundColor: "white",
            overflowY: "auto",
            overflowX: "hidden",
            textAlign: "left",
            padding: "2% 1%",
            width: "100%",
            backgroundColor: Colors.globalColor9,
          }}
        >
          <>
            <div style={{ padding: "0px 5px 0px " }} className="dashSection2">
              <Grid
                container
                alignItems="center"
                spacing={2}
                style={{
                  overflow: "hidden",
                  padding: "2px 0px 10px",
                  // marginTop: "10px",
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={12}
                  lg={12}
                  style={{ paddingBottom: window.innerWidth < 700 && "10px" }}
                >
                  <Grid container spacing={3} style={{ padding: "5px 10px" }}>
                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("0")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("1")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "0" ? (
                              <img
                                src={daily_inspection_white}
                                alt="boxImage"
                                height="50px"
                              />
                            ) : (
                              <img
                                src={daily_inspection}
                                alt="boxImage"
                                height="50px"
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Today's Inspections")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          cursor: "pointer",
                          padding: "10px",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("1")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("2")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "1" ? (
                              <img
                                src={due_inspection_white}
                                alt="boxImage"
                                height="50px"
                              />
                            ) : (
                              <img
                                src={due_inspection}
                                alt="boxImage"
                                height="50px"
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Pending Inspections")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("2")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("3")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "2" ? (
                              <img
                                src={overdue_inspection_white}
                                alt="boxImage"
                                height="45px"
                              />
                            ) : (
                              <img
                                src={overdue_inspection}
                                alt="boxImage"
                                height="45px"
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("OverDue/Late Inspections")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("3")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("4")}
                      >
                        <Grid container>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ textAlign: "center" }}
                          >
                            {hovered === "3" ? (
                              <img
                                src={rejected_white}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            ) : (
                              <img
                                src={rejected}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Rejected Inspections")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Grid container spacing={3} style={{ padding: "5px 10px" }}>
                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("4")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("5")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "4" ? (
                              <img
                                src={failed_inspection_white}
                                alt="boxImage"
                                height="55px"
                                style={{ marginTop: "3px" }}
                              />
                            ) : (
                              <img
                                src={failed_inspection}
                                alt="boxImage"
                                height="55px"
                                style={{ marginTop: "3px" }}
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Recently Completed")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          padding: "10px",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          cursor: "pointer",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("5")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("6")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "5" ? (
                              <img
                                src={review_white}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            ) : (
                              <img
                                src={review}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Review for Approval")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          cursor: "pointer",
                          padding: "10px",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("6")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("8")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "6" ? (
                              <img
                                src={missed_white}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            ) : (
                              <img src={missed} alt="boxImage" height="45px" />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Missed Inspections")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>

                    <Grid
                      item
                      xs={6}
                      sm={3}
                      style={{ maxHeight: "220px", overflow: "hidden" }}
                    >
                      <div
                        className="gradientHover"
                        style={{
                          height: "200px",
                          padding: "10px",
                          cursor: "pointer",
                          borderRadius: "10px",
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: Colors.globalColor4,
                          backgroundColor: "white",
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                        onMouseOver={() => setHovered("7")}
                        onMouseOut={() => setHovered(null)}
                        onClick={() => setOpened("7")}
                      >
                        <Grid
                          container
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{
                              textAlign: "center",
                              flexDirection: "column",
                            }}
                          >
                            {hovered === "7" ? (
                              <img
                                src={assigned_white}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            ) : (
                              <img
                                src={assigned}
                                alt="boxImage"
                                height="50px"
                                style={{ marginTop: "3px" }}
                              />
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            justifyContent="center"
                            alignItems="center"
                            style={{ fontWeight: "bold", overflow: "hidden" }}
                          >
                            <p className="text1Home">
                              <>{t("Assigned Action Plan")}</>
                            </p>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            
            </div>
          </>
        </div>
      </div>
      <Modal open={openOnb}>
        <div className="modal-size" style={{ position: "relative" }}>
          <img src={logo3} width={"80px"} alt="urAudits" />
          <Typography variant="h6" className="modal-title">
            Smart Onboarding
          </Typography>
          <p className="modal-subTitle">
            We want to make sure you find what your looking for. Help us best
            onboard you
          </p>
          <Button
            className="ctBtn"
            onClick={() => {
              handleCloseOnb();
              history.push("/onbording");
            }}
          >
            Let's Get Started
          </Button>

          <div
            onClick={handleCloseOnb}
            style={{
              padding: "5px",
              display: "inline-block",
              color: Colors.globalColor8,
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
            }}
          >
            <p style={{ margin: "0px", fontWeight: "bolder" }}>X</p>
          </div>
        </div>
      </Modal>

      <Modal open={opened == "1"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <TodoContainer getPackageDetails={getPackageDetails} />
        </div>
      </Modal>

      <Modal open={opened == "2"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <PendingContainer />
        </div>
      </Modal>

      <Modal open={opened == "3"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <OverdueContainer />
        </div>
      </Modal>

      <Modal open={opened == "4"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <FailedContainer />
        </div>
      </Modal>

      <Modal open={opened == "5"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "1000px" }}
        >
          <RecentlyCompleted setRecentIns={setRecentIns} />
        </div>
      </Modal>

      <Modal open={opened == "6"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <ReviewForApproval setReviewIns={setReviewIns} />
        </div>
      </Modal>

      <Modal open={opened == "7"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <ActionContainer setAssignedAction={setAssignedAction} />
        </div>
      </Modal>

      <Modal open={opened == "8"} onClose={() => setOpened(null)}>
        <div
          className="modal-size-2"
          style={{ position: "relative", maxWidth: "800px" }}
        >
          <MissedContainer setMissedIns={setMissedIns} />
        </div>
      </Modal>
    </div>
  );
}

function MissedContainer({ setMissedIns }) {
  let company = useSelector((state) => state.companyReducer.company);
  let language = useSelector((state) => state.languageReducer.language);
  let { t } = useTranslation();
  const [inspections, setInspections] = React.useState([]);
  const [totalInspections, setTotalInspections] = React.useState(0);
  const [chartData, setChartData] = React.useState([]);
  const [inspectionLoader, setInspectionLoader] = React.useState(false);
  const [filter, setFilter] = React.useState("");
  const history = useHistory();
  const [series, setSeries] = React.useState([]);
  const [options, setOption] = React.useState({});

  // React.useEffect(
  //   () => {
  //     fetchMissedInspections();
  //   },
  //   [company?.id]
  // );


  // const fetchMissedInspections = () => {
  //   setInspectionLoader(true);
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data?.token;

  //   let params = {
  //     company_id: company?.id,
  //     user_id: data.user_id,
  //     from_d: moment(new Date())
  //       .subtract(1, "months")
  //       .format("YYYY-MM-DD"),
  //     to_d: moment(new Date()).format("YYYY-MM-DD"),
  //   };

  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/ScheduleAssignee/get_missed_schedules?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       console.log(response);
  //       if (response.status === "Success") {
  //         let sch = [];
  //         if (response.data.length == 0) {
  //           setInspections(sch);
  //           setMissedIns(0);
  //         } else {
  //           response.data
  //             .sort(
  //               (a, b) =>
  //                 new Date(b.filter_date).getTime() -
  //                 new Date(a.filter_date).getTime()
  //             )
  //             .map((v, i) => {
  //               let obj = {
  //                 ...v,
  //                 filter_date: moment(v.filter_date).format("MMMM DD, YYYY"),
  //               };

  //               sch.push(obj);
  //             });
  //           setMissedIns(response.data.length);
  //           setInspections(response.data);
  //         }
  //         setInspectionLoader(false);
  //       } else if (
  //         response.error === "jwt expired" ||
  //         response.error === "invalid token" ||
  //         response.error === "invalid signature" ||
  //         response.error === "Unexpected token"
  //       ) {
  //         let status = await refresh_token();
  //         console.log(status);
  //         if (status) {
  //           console.log("opopopop");
  //           fetchMissedInspections();
  //         }
  //       }
  //     })
  //     .catch((error) => console.log(error.message));
  // };

  async function fetchMissedInspections() {
    setInspectionLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let site_obj = {};
    let params = {
      company_id: company?.id,
      user_id: data.user_id,
      from_d: moment(new Date())
        .subtract(1, "months")
        .format("YYYY-MM-DD"),
      to_d: moment(new Date()).format("YYYY-MM-DD"),
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    const response = await fetch(
      GlobalApi + "/ScheduleAssignee/get_missed_schedules?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    if (data2.status === "Success") {

   
      let sch = [];
      if (data2.data.length == 0) {
        return sch;
        setMissedIns(0);
      } else {
        data2.data
          .sort(
            (a, b) =>
              new Date(b.filter_date).getTime() -
              new Date(a.filter_date).getTime()
          )
          .map((v, i) => {
            let obj = {
              ...v,
              filter_date: moment(v.filter_date).format("MMMM DD, YYYY"),
            };

            sch.push(obj);
          });
        setMissedIns(data2.data.length);
        return data2.data;
      }
      setInspectionLoader(false);
    } else if (
      response.error === "jwt expired" ||
      response.error === "invalid token" ||
      response.error === "invalid signature" ||
      response.error === "Unexpected token"
    ) {
      let status = await refresh_token();
      console.log(status);
      if (status) {
        console.log("opopopop");
        fetchMissedInspections();
      }
    }
  }

      // react-query to fetch data
      const { data, isLoading, isFetching, error, setData } = useQuery(
        "missedInspections",
        fetchMissedInspections,
        {
          enabled: true, // Enable initial data fetching
          refetchOnWindowFocus: false, // Disable automatic refetching on window focus
        }
      );

      console.log("fff",data)

  return (
    <div
      variant={"outlined"}
      style={{
        padding: 0,
        borderRadius:'5px',
        backgroundColor: "white",
        height: 350,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Missed Inspections")}</>
        </p>
        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("last 30 days")}</>
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={0}
        style={{ padding: "5px 20px", backgroundColor: "#eaf7fe" }}
      >
        <Grid
          item
          style={{
            width: "200px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Inspection")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Due Date")}</>
          </p>
        </Grid>

      </Grid>

      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      <div
        style={{
          overflowY: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "300px",
          padding: "5px",
        }}
      >
        {isLoading ? (
          <div
            style={{
              height: "290px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <div
            className="scrollbarShow2"
            style={{ padding: "10px", overflowY: "scroll" }}
            id="scrollSection3"
            // onScroll={(e) => handleScroll3(e)}
          >
            {data.length == 0 && (
              <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight:'250px'
                }}
              >
                <NoRecords />
              </div>
            )}
            {data.length > 0 &&
              data
                .sort(
                  (a, b) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
                )
                .map((v) => {
                  console.log("v>>>>>>>>>>>>>>>>abcd", v);
                  return (
                    <div
                      variant={"outlined"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "20px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: Colors.globalColor4,
                        marginBottom: 5,
                        borderRadius: 5,
                        padding: 0,
                      }}
                      // onClick={() =>
                      //   history.push("inspection-edit/" + v.id + "/edit")
                      // }
                      className="new-hover"
                    >
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                        spacing={0}
                        style={{ padding: "0px 10px" }}
                      >
                        <Grid
                          item
                          style={{
                            width: "200px",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: language === "ar" ? "right" : "left",
                          }}
                        >
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            <Tooltip title={v?.title ? v?.title : " "}>
                              <p>
                                {v?.title?.slice(0, 30) +
                                  (v?.title?.length > 30 ? "..." : "")}
                              </p>
                            </Tooltip>
                          </p>
                        </Grid>
                        <Grid item>
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            {moment(new Date(v.filter_date)).format(
                              "MMMM DD, YYYY"
                            )}
                          </p>
                        </Grid>
                        {/* <Grid item>
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            {v?.score}
                          </p>
                        </Grid> */}
                      </Grid>
                    </div>
                  );
                })}
          </div>
        )}
      </div>
      <Grid
        container
        style={{ display: "flex", justifyContent: "center" }}
        spacing={2}
      >
        <Grid
          item
          xs={12}
          style={{
            padding: 0,
            margin: 10,
            backgroundColor: Colors.backgroundColor,
            maxHeight: window.innerHeight * 0.3,
            overflow: "hidden",
            overflowY: "scroll",
          }}
        />
      </Grid>
    </div>
  );
}

function PendingContainer() {
  const containerRef = useRef(null);
  let company = useSelector((state) => state.companyReducer.company);
  const language = useSelector((state) => state.languageReducer.language);
  const [totalInspections, setTotalInspections] = useState(0);
  let { t } = useTranslation();
  const history = useHistory();
  const pageSize = 15; // Number of inspections to fetch per page
  const [isFetchingMore, setIsFetchingMore] = useState(false); // Track if more inspections are being fetched
  const [inspection, setInspections] = useState([]); // List of inspections
  const [pendingInspections, setPendingInspections] = useState([]);

  const getPendingInspections = async () => {
    const localstorage = localStorage.getItem("UserData");
    const data = JSON.parse(localstorage);
    const token = data?.token;
    const response = await fetch(
      GlobalApi +
        "/Inspection/get_pending_inspections?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id +
        "&skip=" +
        0 +
        "&limit=" +
        12,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    setTotalInspections(data2?.total_records);
    return data2;
  };

  const getMorePendingInspections = async (skip) => {
    const localstorage = localStorage.getItem("UserData");
    const data = JSON.parse(localstorage);
    const token = data?.token;
    const response = await fetch(
      GlobalApi +
        "/Inspection/get_pending_inspections?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id +
        "&skip=" +
        skip +
        "&limit=" +
        12,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    return data2?.data;
  };

  // react-query to fetch data
  const { data, isLoading, isFetching, error, setData } = useQuery(
    "pendingInspections",
    getPendingInspections
  );

  useEffect(
    () => {
      if (data) {
        // Update the state with the fetched data
        setPendingInspections(data?.data);
      }
    },
    [data]
  );

  const handleScroll = async (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    // console.log(scrollHeight - scrollTop,clie  ntHeight);
    console.log(scrollTop, clientHeight, scrollHeight, "jjj");
    if (scrollHeight - scrollTop <= clientHeight + 5) {
      console.log("fetch more data");
      const newData = await getMorePendingInspections(
        pendingInspections?.length
      );
      setPendingInspections((prevData) => [...prevData, ...newData]);
    }
  };

  console.log(pendingInspections);

  return (
    <div style={{ backgroundColor: "white", borderRadius: "5px" }}>
      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Pending Inspections")}</>
        </p>
        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("showing records")}</> {pendingInspections.length} <>{t("of")}</>{" "}
          {totalInspections}
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={0}
        style={{ padding: "5px 20px", backgroundColor: "#eaf7fe" }}
      >
        <Grid
          item
          style={{
            width: "250px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Inspection")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Date")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Score")}</>
          </p>
        </Grid>
      </Grid>

      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      {isLoading ? (
        <div
          style={{
            height: "290px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <div
          ref={containerRef}
          onScroll={(e) => handleScroll(e)}
          style={{ height: "300px", overflowY: "auto", padding: 10 }}
        >
          {pendingInspections.length == 0 && (
            <div
              style={{
                height: "290px",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NoRecords />
            </div>
          )}
          {pendingInspections.length > 0 &&
            pendingInspections
              .sort(
                (a, b) =>
                  new Date(b.createdAt).getTime() -
                  new Date(a.createdAt).getTime()
              )
              .map((v) => (
                <div
                  variant={"outlined"}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "20px",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderColor: Colors.globalColor4,
                    marginBottom: 5,
                    borderRadius: 5,
                    padding: 0,
                  }}
                  onClick={() =>
                    history.push("inspection-edit/" + v.id + "/edit")
                  }
                  className="new-hover"
                >
                  <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    spacing={0}
                    style={{ padding: "0px 10px" }}
                  >
                    <Grid
                      item
                      style={{
                        width: "250px",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <p
                        className="templateName"
                        style={{
                          margin: "2px 0px",
                          textAlign: language === "ar" ? "right" : "left",
                        }}
                      >
                        <Tooltip
                          title={v?.Schedule?.title ? v?.Schedule?.title : " "}
                        >
                          <p>
                            {v?.Schedule?.title.slice(0, 30) +
                              (v?.Schedule?.title.length > 30 ? "..." : "")}
                          </p>
                        </Tooltip>
                      </p>
                    </Grid>
                    <Grid item>
                      <p className="templateName" style={{ margin: "2px 0px" }}>
                        {moment(new Date(v.createdAt)).format("MMMM DD, YYYY")}
                      </p>
                    </Grid>
                    <Grid item>
                      <p className="templateName" style={{ margin: "2px 0px" }}>
                        {v?.score}
                      </p>
                    </Grid>
                  </Grid>
                </div>
              ))}

          {isFetchingMore && <div>Loading more inspections...</div>}
        </div>
      )}
    </div>
  );
}

function RecentlyCompleted({ setRecentIns }) {
  const classes = useStyles();
  const containerRef2 = useRef(null);
  let { t } = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [inspectionLoader, setInspectionLoader] = React.useState(false);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  let history = useHistory();

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: <>{t("Name")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Template",
      numeric: false,
      disablePadding: false,
      label: <>{t("Template")}</>,
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "Site",
      numeric: false,
      disablePadding: false,
      label: <>{t("Site")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Date",
      numeric: false,
      disablePadding: false,
      label: <>{t("Date")}</>,
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "Score",
      numeric: true,
      disablePadding: false,
      label: <>{t("Score")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Status",
      numeric: false,
      disablePadding: false,
      label: <>{t("Status")}</>,
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "Assigned To",
      numeric: false,
      disablePadding: false,
      label: <>{t("Assigned To")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Action",
      numeric: false,
      disablePadding: false,
      label: <>{t("Action")}</>,
      borderLeft: language == "ar" ? false : true,
      borderRight: language == "ar" ? true : false,
    },
  ];

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {/* <TableCell padding="checkbox">
            <Checkbox />
          </TableCell> */}
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={language === "ar" ? "right" : "left"}
              style={{
                padding: "8px",
                fontWeight: "bold",
                borderTop: "1px solid #dadada",
                borderLeft: headCell.borderLeft ? "1px solid #dadada" : "none",
                borderRight: headCell.borderRight
                  ? "1px solid #dadada"
                  : "none",
                color: Colors.globalColor8,
                textTransform: "capitalize",
              }}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {/* <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{textAlign:headCell.numeric === true ? "center" : "left"}}
              > */}

              {headCell.label}

              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
              {/* </TableSortLabel> */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const getInspection = async () => {
    setInspectionLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company?.id,
      user_id: data.user_id,
      skip: 0,
      limit: 15,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    const response = await fetch(
      GlobalApi + "/Inspection/get_recent_completed_inspections?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    const data2 = await response.json();
    if (data2.status === "Success") {
      setTotalRecords(data2.total_records);
      return data2;
    } else if (
      response.error === "jwt expired" ||
      response.error === "invalid token" ||
      response.error === "invalid signature" ||
      response.error === "Unexpected token"
    ) {
      let status = await refresh_token();
      console.log(status);
      if (status) {
        console.log("opopopop");
        getInspection();
      }
    }
  };

  const getMoreInspection = async (skip) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company?.id,
      user_id: data.user_id,
      skip: skip,
      limit: 15,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    const response = await fetch(
      GlobalApi + "/Inspection/get_recent_completed_inspections?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    const data2 = await response.json();
    console.log(data2, "data2");
    if (data2.status == "Success") {
      setTotalRecords(data2.total_records);
      return data2;
    } else if (
      response.error === "jwt expired" ||
      response.error === "invalid token" ||
      response.error === "invalid signature" ||
      response.error === "Unexpected token"
    ) {
      let status = await refresh_token();
      console.log(status);
      if (status) {
        console.log("opopopop");
        getInspection();
      }
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);
  const ModalOpen = (row) => {
    setIsModalOpen(row);
  };

  const { data, isLoading, isFetching, error, setData } = useQuery(
    "recentlyCompletedInspections",
    getInspection
  );

  useEffect(
    () => {
      if (data) {
        // Update the state with the fetched data
        setRows(data?.data);
      }
    },
    [data]
  );

  const handleScroll4 = async (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    console.log(scrollTop, clientHeight, scrollHeight, "jjj");

    if (scrollHeight - scrollTop <= clientHeight + 5) {
      if (rows?.length < totalRecords) {
        const newData = await getMoreInspection(rows?.length);
        console.log(newData, "newData");
        let newRows = [...newData.data];
        setRows((prevData) => [...prevData, ...newRows]);
      }
    }
  };

  return (
    <div
      className="scrollHidden "
      variant={"outlined"}
      style={{
        padding: 0,
        paddingBottom: 10,
        backgroundColor: "white",
        height: "340px",
        borderRadius:"5px"
      }}
    >
      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Recently Completed")}</>
        </p>
        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("showing records")}</> {rows.length} <>{t("of")}</>{" "}
          {totalRecords}
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      {isLoading && (
        <div
          style={{
            height: "290px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      )}
      {!isLoading && (
        <>
          {rows?.length == 0 && (
            <div
              style={{
                height: "290px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <NoRecords />
            </div>
          )}

          <div>
            {rows?.length !== 0 && (
              <div style={{ padding: "0px", overflow: "hidden", padding: 10 }}>
                {window.innerWidth > 500 && (
                  <TableContainer
                    className={classes.container}
                    ref={containerRef2}
                    onScroll={(e) => handleScroll4(e)}
                    style={{ height: "300px", overflowY: "auto" }}
                    // style={{ width: "100%" }}
                  >
                    <Table
                      className={classes.table}
                      stickyHeader
                      aria-label="sticky table"
                      size={dense ? "small" : "medium"}
                      style={{
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                      }}
                    >
                      <EnhancedTableHead
                        classes={classes}
                        numSelected={selected.length}
                        order={order}
                        orderBy={orderBy}
                        onRequestSort={handleRequestSort}
                        rowCount={rows.length}
                      />
                      <TableBody>
                        {rows.length !== 0 &&
                          stableSort(
                            rows.filter(
                              (v) =>
                                v.schedule_title
                                  ?.toLowerCase()
                                  .includes(searchText?.toLowerCase()) ||
                                v.TemplateInspection.title
                                  ?.toLowerCase()
                                  .includes(searchText?.toLowerCase())
                            ),
                            getComparator(order, orderBy)
                          ).map((row, index) => {
                            console.log(
                              "ROW>>PPPPPPPPPPPPPPPPPPPP>>>>>>>>>>",
                              row
                            );
                            const isItemSelected = isSelected(row.name);
                            const labelId = `enhanced-table-checkbox-${index}`;

                            return (
                              <TableRow
                                hover
                                onClick={(event) =>
                                  handleClick(event, row.name)
                                }
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.name}
                                className="testingtable"
                                style={{ cursor: "pointer" }}
                              >
                                <TableCell
                                  component="th"
                                  id={labelId}
                                  scope="row"
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    textAlign:
                                      language === "ar" ? "right" : "left",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      row?.Schedule?.title
                                        ? row?.Schedule?.title
                                        : " "
                                    }
                                  >
                                    <p style={{ margin: 0 }}>
                                      {row.schedule_title.slice(0, 20) +
                                        (row.schedule_title.length > 20
                                          ? "..."
                                          : "")}
                                    </p>
                                  </Tooltip>
                                </TableCell>
                                <TableCell
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    borderLeft: "1px solid #dadada",
                                    borderRight: "1px solid #dadada",
                                    textAlign:
                                      language === "ar" ? "right" : "left",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      row?.TemplateInspection?.title
                                        ? row?.TemplateInspection?.title
                                        : " "
                                    }
                                  >
                                    <p style={{ margin: 0 }}>
                                      {row.TemplateInspection.title.slice(
                                        0,
                                        30
                                      ) +
                                        (row?.TemplateInspection?.title
                                          ?.length > 30
                                          ? "..."
                                          : "")}
                                    </p>
                                  </Tooltip>
                                </TableCell>

                                <TableCell
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    textAlign:
                                      language === "ar" ? "right" : "left",
                                  }}
                                >
                                  {row?.Schedule?.Site?.title}
                                </TableCell>
                                <TableCell
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    borderLeft: "1px solid #dadada",
                                    borderRight: "1px solid #dadada",
                                    textAlign:
                                      language === "ar" ? "right" : "left",
                                  }}
                                >
                                  {moment(row?.Schedule?.createdAt).format(
                                    "DD/MM/YYYY"
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    textAlign:
                                      language === "ar" ? "right" : "left",
                                  }}
                                >
                                  {row?.score ? row.score : 0}%
                                </TableCell>
                                <TableCell
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    borderLeft: "1px solid #dadada",
                                    borderRight: "1px solid #dadada",
                                    textAlign:
                                      language === "ar" ? "right" : "left",
                                  }}
                                >
                                  {row.isCompleted === true
                                    ? "completed"
                                    : "Incomplete"}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  style={{
                                    paddingTop: "2px",
                                    paddingBottom: "2px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      maxWidth: "150px",
                                    }}
                                    className="scrollHidden"
                                  >
                                    {row?.Schedule?.ScheduleAssignees.map(
                                      (v, i) => {
                                        if (i <= 2) {
                                          return (
                                            <>
                                              <Tooltip
                                                title={
                                                  v?.User?.first_name +
                                                  " " +
                                                  v?.User?.first_name
                                                }
                                              >
                                                {v?.User?.avatar == null ? (
                                                  <div
                                                    style={{
                                                      width: 30,
                                                      height: 30,
                                                      borderRadius: "50px",
                                                      border:
                                                        "1px solid #043077",
                                                      color: "#043077",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      margin: 1,
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        margin: 0,
                                                        fontWeight: "bold",
                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      {v?.User
                                                        ? v?.User?.first_name
                                                            .substring(0, 1)
                                                            .toUpperCase()
                                                            .concat(
                                                              v?.User
                                                                ? v?.User?.last_name
                                                                    .substring(
                                                                      0,
                                                                      1
                                                                    )
                                                                    .toUpperCase()
                                                                : ""
                                                            )
                                                        : ""}
                                                    </p>
                                                  </div>
                                                ) : (
                                                  <div
                                                    style={{
                                                      width: 30,
                                                      height: 30,
                                                      borderRadius: "50px",
                                                      color: "#043077",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      margin: 1,
                                                      alignItems: "center",
                                                      backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                        v?.User?.avatar
                                                      })`,
                                                      backgroundSize: "cover",
                                                    }}
                                                  />
                                                )}
                                              </Tooltip>
                                            </>
                                          );
                                        }
                                      }
                                    )}
                                  </div>
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{
                                    paddingTop: "5px",
                                    paddingBottom: "5px",
                                    borderLeft:
                                      language == "ar"
                                        ? "none"
                                        : "1px solid #dadada",
                                    borderRight:
                                      language == "ar"
                                        ? "1px solid #dadada"
                                        : "none",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: 0,
                                    }}
                                  >
                                    <>
                                      <img
                                        src={pencil}
                                        alt="file"
                                        width={20}
                                        onClick={() =>
                                          history.push(
                                            "inspection-edit/" +
                                              row.id +
                                              "/edit"
                                          )
                                        }
                                      />
                                    </>
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {window.innerWidth <= 500 && (
                  <div
                    className={classes.container}
                    style={{
                      overflowY: "scroll",
                      width: "100%",
                      padding: "5px",
                    }}
                    id="InspectionScroll"
                    onScroll={(e) => handleScroll4(e)}
                  >
                    {rows.length !== 0 &&
                      stableSort(
                        rows.filter(
                          (v) =>
                            v.schedule_title
                              ?.toLowerCase()
                              .includes(searchText?.toLowerCase()) ||
                            v.TemplateInspection.title
                              ?.toLowerCase()
                              .includes(searchText?.toLowerCase())
                        ),
                        getComparator(order, orderBy)
                      ).map((row, index) => {
                        return (
                          <div
                            className="hover shadow"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              border: "1px solid #dadada",
                              padding: "10px",
                              margin: "5px",
                              flexDirection: "row",
                              alignItems: "center",
                              textAlign: "left",
                              height: "220px",
                              borderRadius: "5px",
                              backgroundColor: "white",
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                height: "100%",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    color: Colors.globalColor8,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  <>{t("Name")}</>
                                </p>

                                <p
                                  style={{
                                    fontSize: "12px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  {row.schedule_title.slice(0, 20) +
                                    (row.schedule_title.length > 20
                                      ? "..."
                                      : "")}
                                </p>
                              </div>
                              <div>
                                <p
                                  style={{
                                    color: Colors.globalColor8,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  <>{t("Template")}</>
                                </p>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  {row.TemplateInspection.title.slice(0, 30) +
                                    (row?.TemplateInspection?.title?.length > 30
                                      ? "..."
                                      : "")}
                                </p>
                              </div>
                              <div>
                                <p
                                  style={{
                                    color: Colors.globalColor8,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  <>{t("Status")}</>
                                </p>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  {row?.site_title}
                                </p>
                              </div>
                              <div>
                                <p
                                  style={{
                                    color: Colors.globalColor8,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  Assigned to{" "}
                                </p>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    maxWidth: "150px",
                                  }}
                                  className="scrollHidden"
                                >
                                  {row?.Schedule?.ScheduleAssignees.map(
                                    (v, i) => {
                                      if (i <= 2) {
                                        return (
                                          <>
                                            <Tooltip
                                              title={
                                                v?.User?.first_name +
                                                " " +
                                                v?.User?.first_name
                                              }
                                            >
                                              {v?.User?.avatar == null ? (
                                                <div
                                                  style={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50px",
                                                    border: "1px solid #043077",
                                                    color: "#043077",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    margin: 1,
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      margin: 0,
                                                      fontWeight: "bold",
                                                      fontSize: "10px",
                                                    }}
                                                  >
                                                    {v?.User
                                                      ? v?.User?.first_name
                                                          .substring(0, 1)
                                                          .toUpperCase()
                                                          .concat(
                                                            v?.User
                                                              ? v?.User?.last_name
                                                                  .substring(
                                                                    0,
                                                                    1
                                                                  )
                                                                  .toUpperCase()
                                                              : ""
                                                          )
                                                      : ""}
                                                  </p>
                                                </div>
                                              ) : (
                                                <div
                                                  style={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50px",
                                                    color: "#043077",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    margin: 1,
                                                    alignItems: "center",
                                                    backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                      v?.User?.avatar
                                                    })`,
                                                    backgroundSize: "cover",
                                                  }}
                                                />
                                              )}
                                            </Tooltip>
                                          </>
                                        );
                                      }
                                    }
                                  )}
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                height: "100%",
                                flexDirection: "column",
                                justifyContent: "space-between",
                              }}
                            >
                              <div>
                                <p
                                  style={{
                                    color: Colors.globalColor8,
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                  }}
                                >
                                  {row.score ? row.score : 0}%
                                </p>
                              </div>
                              <div>
                                <Tooltip
                                  title={moment(row.createdAt).format(
                                    "DD MMMM YYYY"
                                  )}
                                >
                                  <p style={{ margin: 0 }}>
                                    <EventIcon
                                      style={{ color: Colors.globalColor8 }}
                                    />
                                  </p>
                                </Tooltip>
                              </div>

                              {row.isCompleted == true && (
                                <div>
                                  <DoneAllIcon style={{ color: "green" }} />
                                </div>
                              )}

                              <div>
                                <img
                                  src={pencil}
                                  alt="file"
                                  width={20}
                                  onClick={() =>
                                    history.push(
                                      "inspection-edit/" + row.id + "/edit"
                                    )
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

function ActionContainer({ setAssignedAction }) {
  let { t } = useTranslation();
  const classes = useStyles();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  let routeTracking = useSelector((state) => state.routeTrackingReducer);
  const [inspections, setInspections] = React.useState([]);
  const [chartData, setChartData] = React.useState([]);
  const [filter, setFilter] = React.useState("");
  const [actionLoader, setActionLoader] = React.useState(false);
  const history = useHistory();
  const [series, setSeries] = React.useState([]);
  const [fetchActionsAssign, setFetchActionsAssign] = React.useState(false);
  const [actionPlanData, setActionPlanData] = React.useState([]);
  const [totalActionPlans, setTotalActionPlans] = React.useState(0);



  async function fetchActions() {
    setFetchActionsAssign(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    let params = {
      skip: 0,
      limit: 15,
      user_id: data.user_id,
      company_id: company?.id,
    };
    //console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    const response = await fetch(
      GlobalApi + "/Action/get_assigned_action?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    const data2 = await response.json();
    console.log("data2 >>>>>>>>>", data2);

    if (data2.msg === "success") {
      setTotalActionPlans(data2.total_records);
      setAssignedAction(data2.total_records);
      setFetchActionsAssign(false);
      console.log("data2 >>>>>>>>>", data2);




      if (data2.action.length == 0) {
        setActionPlanData([]);
      } else {
        let inCompletedActions = [];
        data2.action.map((v) => {
          if (v.status !== "Complete") {
            inCompletedActions.push(v);
          }
          setFetchActionsAssign(false);
        });
        console.log("inCompletedActions >>>>>>>>>", inCompletedActions);

        if (inCompletedActions.length != 0) {
          return inCompletedActions.sort(function(a, b) {
            return (
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            );
          });
        } else {
          return [];
        }
      }
    } else {
      setFetchActionsAssign(false);
    }
  }

  async function fetchMoreActions(skip) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    let params = {
      skip: skip,
      limit: 15,
      user_id: data.user_id,
      company_id: company?.id,
    };
    //console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    const response = await fetch(
      GlobalApi + "/Action/get_assigned_action?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    const data2 = await response.json();
    if (data2.msg === "success") {
      setTotalActionPlans(data2.total_records);
      let inCompletedActions = [];

      data2.action.map((v) => {
        if (v.status !== "Complete") {
          inCompletedActions.push(v);
        }
      });

      return inCompletedActions;
    } else {
      setFetchActionsAssign(false);
    }
  }


    // react-query to fetch data
    const { data, isLoading, isFetching, error, setData } = useQuery(
      "assignedActions",
      fetchActions,
      {
        enabled: true, // Enable initial data fetching
        refetchOnWindowFocus: false, // Disable automatic refetching on window focus
      }
    );

  useEffect(
    () => {
      if (data) {
        // Update the state with the fetched data
        console.log(data, "data")
        setActionPlanData(data);
      }
    },
    [data]
  );

  const handleScroll6 = async (e) => {

    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    console.log(scrollTop, clientHeight, scrollHeight, "jjj");

    if (scrollHeight - scrollTop <= clientHeight + 5) {
      if (actionPlanData?.length < totalActionPlans) {
        const newData = await fetchMoreActions(actionPlanData?.length);
        console.log(newData, "newData");
        let newRows = [...newData];
        let finalData = [...actionPlanData, ...newRows];
        let sorted = finalData.sort(function(a, b) {
          return (
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        });
        setActionPlanData(sorted);
      }
    }
  };

  console.log("actionPlanData", actionPlanData);

  return (
    <div
      className="scrollHidden "
      variant={"outlined"}
      style={{
        padding: 0,
        borderRadius:'5px',
        backgroundColor: "white",
        height: "340px",
      }}
    >
      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Assigned Action Plan")}</>
        </p>
        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("showing records")}</> {actionPlanData?.length}{" "}
          <>{t("of")}</> {totalActionPlans}
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      {isLoading ? (
        <div
          style={{
            height: "290px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <div style={{ padding: "0px" }}>
          <div
            id="scrollSection6"
            onScroll={(e) => handleScroll6(e)}
            className="scrollbarShow2"
            style={{
              width: "100%",
              padding: window.innerWidth > 500 && "10px",
              marginRight: language == "ar" ? 0 : "20px",
              marginLeft: language == "ar" ? "20px" : "0px",
              overflowY: "auto",
              // height: "290px",
            }}
          >
            {actionPlanData && actionPlanData?.length == 0 && (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight:'250px'
                }}
              >
                <NoRecords />
              </div>
            )}
            {actionPlanData && actionPlanData?.length > 0 && (
              <>
                {window.innerWidth > 500 && (
                  <TableContainer className={classes.container}>
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      style={{
                        borderLeft: "1px solid #dadada",
                        borderRight: "1px solid #dadada",
                      }}
                    >
                      <TableHead style={{ backgroundColor: "#f2f2f2" }}>
                        <TableRow>
                          <TableCell
                            style={{
                              padding: "8px",
                              fontWeight: "bold",
                              borderTop: "1px solid #dadada",
                              color: Colors.globalColor8,
                              textTransform: "capitalize",
                              textAlign: language == "ar" ? "right" : "left",
                            }}
                          >
                            <>{t("Name")}</>
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "8px",
                              fontWeight: "bold",
                              borderTop: "1px solid #dadada",
                              borderLeft: "1px solid #dadada",
                              borderRight: "1px solid #dadada",
                              color: Colors.globalColor8,
                              textAlign: language == "ar" ? "right" : "left",
                            }}
                          >
                            <>{t("Priority")}</>
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "8px",
                              fontWeight: "bold",
                              borderTop: "1px solid #dadada",
                              color: Colors.globalColor8,
                              textAlign: language == "ar" ? "right" : "left",
                            }}
                          >
                            <>{t("Status")}</>
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "8px",
                              fontWeight: "bold",
                              borderTop: "1px solid #dadada",
                              borderLeft: "1px solid #dadada",
                              borderRight: "1px solid #dadada",
                              color: Colors.globalColor8,
                              textAlign: language == "ar" ? "right" : "left",
                            }}
                          >
                            <>{t("Due Date")}</>
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "8px",
                              fontWeight: "bold",
                              borderTop: "1px solid #dadada",
                              borderRight: "1px solid #dadada",
                              color: Colors.globalColor8,
                              textAlign: language == "ar" ? "right" : "left",
                            }}
                          >
                            {t("Inspection")}
                          </TableCell>
                          <TableCell
                            style={{
                              padding: "8px",
                              fontWeight: "bold",
                              borderTop: "1px solid #dadada",
                              color: Colors.globalColor8,
                              textAlign: language == "ar" ? "right" : "left",
                            }}
                          />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {actionPlanData.map((v) => {
                          return (
                            <TableRow>
                              <TableCell
                                style={{
                                  textAlign: "center",

                                  padding: "8px",
                                }}
                              >
                                <Tooltip title={v?.title ? v?.title : " "}>
                                  <p style={{ margin: "0px" }}>
                                    {v?.title?.slice(0, 10) +
                                      (v?.title?.length > 10 ? "..." : "")}
                                  </p>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  borderLeft: "1px solid #dadada",
                                  borderRight: "1px solid #dadada",
                                  padding: "8px",
                                }}
                              >
                                {v?.priority?.split(" ")[0]}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",

                                  padding: "8px",
                                }}
                              >
                                {v.status}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  borderLeft: "1px solid #dadada",
                                  borderRight: "1px solid #dadada",
                                  padding: "8px",
                                }}
                              >
                                {v.due
                                  ? moment(new Date(v.due)).format(
                                      "MMMM DD, YYYY"
                                    )
                                  : "-"}
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                  borderRight: "1px solid #dadada",
                                  padding: "8px",
                                }}
                              >
                                <Tooltip
                                  title={
                                    v.inspection
                                      ? v?.inspection?.schedule_title
                                      : "N/A"
                                  }
                                >
                                  <p
                                    style={{ margin: "0px" }}
                                    onClick={() => {
                                      v.inspection_id &&
                                        history.push(
                                          "/inspection-edit/" +
                                            v.inspection_id +
                                            "/edit"
                                        );
                                    }}
                                  >
                                    {v.inspection
                                      ? v?.inspection?.schedule_title.slice(
                                          0,
                                          10
                                        ) +
                                        (v?.inspection?.schedule_title.length >
                                        10
                                          ? "..."
                                          : "")
                                      : "N/A"}
                                  </p>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "center",

                                  padding: "8px",
                                }}
                              >
                                <img
                                  src={chat}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => history.push("/task/" + v.id)}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {window.innerWidth <= 500 && (
                  <div
                    className={classes.container}
                    style={{
                      overflowY: "scroll",
                      width: "100%",
                      padding: "5px",
                    }}
                  >
                    {actionPlanData?.map((v) => {
                      return (
                        <div
                          className="hover shadow"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            border: "1px solid #dadada",
                            padding: "10px",
                            margin: "5px",
                            flexDirection: "row",
                            alignItems: "center",
                            textAlign: "left",
                            height: "220px",
                            borderRadius: "5px",
                            backgroundColor: "white",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              height: "100%",
                              flexDirection: "column",
                              justifyContent: "space-between",
                            }}
                          >
                            {v.priority && (
                              <div>
                                {v.priority == "High Priority" && (
                                  <div
                                    style={{
                                      backgroundColor: "#B00020",
                                      display: "inline-block",
                                      textAlign: "left",
                                      padding: "2px 10px",
                                      borderRadius: "20px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: "0px",
                                        color: "white",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {v.priority.split(" ")[0]}
                                    </p>
                                  </div>
                                )}

                                {v.priority == "Medium Priority" && (
                                  <div
                                    style={{
                                      backgroundColor: "#299617",
                                      display: "inline-block",
                                      textAlign: "left",
                                      padding: "2px 10px",
                                      borderRadius: "20px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: "0px",
                                        color: "white",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {v.priority.split(" ")[0]}
                                    </p>
                                  </div>
                                )}

                                {v.priority == "Low Priority" && (
                                  <div
                                    style={{
                                      backgroundColor: "#EEB609",
                                      display: "inline-block",
                                      textAlign: "left",
                                      padding: "2px 10px",
                                      borderRadius: "20px",
                                    }}
                                  >
                                    <p
                                      style={{
                                        margin: "0px",
                                        color: "white",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                      }}
                                    >
                                      {v.priority.split(" ")[0]}
                                    </p>
                                  </div>
                                )}
                              </div>
                            )}

                            <div>
                              <p
                                style={{
                                  color: Colors.globalColor8,
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                <>{t("Name")}</>
                              </p>

                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                {v?.title?.slice(0, 30) +
                                  (v?.title?.length > 30 ? "..." : "")}
                              </p>
                            </div>

                            <div>
                              <p
                                style={{
                                  color: Colors.globalColor8,
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                <>{t("Due Date")}</>
                              </p>

                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                {moment(new Date(v.due)).format(
                                  "MMMM DD, YYYY"
                                )}
                              </p>
                            </div>

                            <div>
                              <p
                                style={{
                                  color: Colors.globalColor8,
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                <>{t("Status")}</>
                              </p>
                              <p
                                style={{
                                  fontSize: "12px",
                                  textAlign: "left",
                                  marginBottom: "0px",
                                  marginTop: "0px",
                                }}
                              >
                                {v.status ? v.status : "To Do"}
                              </p>
                            </div>
                          </div>

                          <div
                            style={{
                              display: "flex",
                              height: "100%",
                              flexDirection: "column",
                              justifyContent: "flex-end",
                            }}
                          >
                            <div>
                              <img
                                src={chat}
                                alt="chat"
                                onClick={() => history.push("/task/" + v.id)}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function ReviewForApproval({ setReviewIns }) {
  let { t } = useTranslation();
  const classes = useStyles();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  let user = useSelector((state) => state.userReducer.user);
  let routeTracking = useSelector((state) => state.routeTrackingReducer);
  const [selected, setSelected] = React.useState([]);
  const [dense, setDense] = React.useState(false);
  const [inspectionLoaderss, setInspectionLoader] = React.useState(true);
  const [totalReviews, setTotalReviews] = React.useState(0);
  const [rows, setRows] = React.useState([]);
  const [rows2, setRows2] = React.useState([]);
  let history = useHistory();

  async function getReviewInspection() {
    setInspectionLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let site_obj = {};

    let params = {
      skip: 0,
      limit: 15,
      company_id: company?.id,
      user_id: data.user_id,
      all_companies: false,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    const response = await fetch(
      GlobalApi + "/Inspection/inspections_for_approval?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    console.log(data2,"ppp7")
  
    return data2?.data2;
  }

      // react-query to fetch data
      const { data,isLoading,  isFetching, error, setData } = useQuery(
        "reviewInspections",
        getReviewInspection,
        {
          enabled: true, // Enable initial data fetching
          refetchOnWindowFocus: false, // Disable automatic refetching on window focus
        }
      );




  const isSelected = (name) => selected.indexOf(name) !== -1;
  console.log("ROW>>>>>>>>>>>>", data);


  return (
    <div
      className="scrollHidden"
      variant={"outlined"}
      style={{
        padding: 0,
        borderRadius:'5px',

        backgroundColor: "white",
        height: "340px",
      }}
    >
      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Review for Approval")}</>
        </p>

        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("last 30 days")}</>
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      {isLoading && (
        <div
          style={{
            height: "290px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner />
        </div>
      )} 
       {!isLoading && data.length == 0 && (
        <div
          style={{
            height: "290px",
            marginTop: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <NoRecords />
        </div>
      )}
      {!isLoading && data.length !== 0 && (
        <div style={{ padding: "0px" }}>
         
          <div
            id="scrollSection5" //  onScroll={(e)=>handleScroll5(e)}
            className="scrollbarShow2"
            style={{
              width: "100%",
              padding: window.innerWidth > 500 && "10px",
              marginRight: language == "ar" ? 0 : "20px",
              marginLeft: language == "ar" ? "20px" : "0px",
              overflowY: "auto",
            }}
          >
            {window.innerWidth > 500 && (
              <TableContainer
                className={classes.container}
                style={{ width: "100%" }}
              >
                <Table
                  className={classes.table}
                  stickyHeader
                  aria-label="sticky table"
                  size={dense ? "small" : "medium"}
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    borderLeft: "1px solid #dadada",
                    borderRight: "1px solid #dadada",
                  }}
                >
                  <TableHead style={{ backgroundColor: "#f2f2f2" }}>
                    <TableRow>
                      <TableCell
                        style={{
                          padding: "8px",
                          fontWeight: "bold",
                          borderTop: "1px solid #dadada",
                          color: Colors.globalColor8,
                          textTransform: "capitalize",
                          textAlign: language == "ar" ? "right" : "left",
                        }}
                      >
                        <>{t("Name")}</>
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "8px",
                          fontWeight: "bold",
                          borderTop: "1px solid #dadada",
                          borderLeft: "1px solid #dadada",
                          borderRight: "1px solid #dadada",
                          color: Colors.globalColor8,
                          textTransform: "capitalize",
                          textAlign: language == "ar" ? "right" : "left",
                        }}
                      >
                        <>{t("Template")}</>
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "8px",
                          fontWeight: "bold",
                          borderTop: "1px solid #dadada",
                          color: Colors.globalColor8,
                          textTransform: "capitalize",
                          textAlign: language == "ar" ? "right" : "left",
                        }}
                      >
                        <>{t("Score")}</>
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "8px",
                          fontWeight: "bold",
                          borderTop: "1px solid #dadada",
                          borderLeft: "1px solid #dadada",
                          borderRight: "1px solid #dadada",
                          color: Colors.globalColor8,
                          textTransform: "capitalize",
                          textAlign: language == "ar" ? "right" : "left",
                        }}
                      >
                        <>{t("Status")}</>
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "8px",
                          fontWeight: "bold",
                          borderTop: "1px solid #dadada",
                          color: Colors.globalColor8,
                          textTransform: "capitalize",
                          textAlign: language == "ar" ? "right" : "left",
                        }}
                      >
                        <>{t("Inspector")}</>
                      </TableCell>
                      <TableCell
                        style={{
                          padding: "8px",
                          fontWeight: "bold",
                          borderTop: "1px solid #dadada",
                          borderLeft:
                            language == "ar" ? "none" : "1px solid #dadada",
                          borderRight:
                            language == "ar" ? "1px solid #dadada" : "none",
                          color: Colors.globalColor8,
                          textTransform: "capitalize",
                          textAlign: language == "ar" ? "right" : "left",
                        }}
                      >
                        <>{t("Pending")}</>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  
                    {!isLoading && (
                      <>
                        {data.length !== 0 ? (
                          data.map((row, index) => {
                            
                            const isItemSelected = isSelected(row.name);
                            const labelId = `enhanced-table-checkbox-${index}`;
                            console.log(
                              "row.inspection.InspectionReviews[0].user_id",
                              row.inspection.InspectionReviews[0].user_id
                            );
                            console.log("user.id", user);

                            console.log(
                              "currentReviewer____________________________________________________________________________________________________",
                              row
                            );

                            let finalReviewer = "";
                            const A = row.inspection.InspectionReviews;
                            const B = row.inspection.InspectionComments;
                            const finalArray = A.filter(
                              (a) =>
                                !B.map(
                                  (b) => b.hierarchy_organization_id
                                ).includes(a.heirarchy_organization_id)
                            );
                            console.log(
                              finalArray,
                              "LLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL"
                            );
                            finalArray.forEach((item) => {
                              if (item.user_id == user.user_id) {
                                finalReviewer = item.heirarchy_organization_id;
                              }
                            });

                            console.log(
                              "finalReviewer_______________________",
                              finalReviewer
                            );

                            return (
                              <TableRow
                                hover
                                role="checkbox"
                                aria-checked={isItemSelected}
                                tabIndex={-1}
                                key={row.name}
                                className="testingtable"
                                style={{ minHeight: "100px" }}
                                onClick={() =>
                                  history.push(
                                    "inspection-edit/" +
                                      row.inspection.id +
                                      "/" +
                                      finalReviewer
                                  )
                                }
                              >
                                <TableCell
                                  component="th"
                                  id={labelId}
                                  scope="row"
                                  style={{
                                    padding: "10px",
                                    textAlign:
                                      language == "ar" ? "right" : "left",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      row.inspection.schedule_title
                                        ? row.inspection.schedule_title
                                        : " "
                                    }
                                  >
                                    <>
                                      {row.inspection.schedule_title.slice(
                                        0,
                                        15
                                      ) +
                                        (row.inspection.schedule_title.length >
                                        15
                                          ? "..."
                                          : "")}
                                    </>
                                  </Tooltip>
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "8px",
                                    borderLeft: "1px solid #dadada",
                                    borderRight: "1px solid #dadada",
                                    textAlign:
                                      language == "ar" ? "right" : "left",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      row.inspection.TemplateInspection.title
                                        ? row.inspection.TemplateInspection
                                            .title
                                        : " "
                                    }
                                  >
                                    <>
                                      {row.inspection.TemplateInspection.title.slice(
                                        0,
                                        15
                                      ) +
                                        (row.inspection.TemplateInspection.title
                                          .length > 15
                                          ? "..."
                                          : "")}
                                    </>
                                  </Tooltip>
                                </TableCell>

                                <TableCell
                                  style={{
                                    padding: "10px",
                                    textAlign:
                                      language == "ar" ? "right" : "left",
                                  }}
                                >
                                  {row.inspection.score
                                    ? row.inspection.score
                                    : 0}
                                  %
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "10px",
                                    borderLeft: "1px solid #dadada",
                                    borderRight: "1px solid #dadada",
                                    textAlign:
                                      language == "ar" ? "right" : "left",
                                  }}
                                >
                                  {row.inspection.isCompleted === true
                                    ? "completed"
                                    : "Incomplete"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: "10px",
                                    textAlign:
                                      language == "ar" ? "right" : "left",
                                  }}
                                >
                                  {(row.inspector.first_name &&
                                    row.inspector.first_name) +
                                    " " +
                                    (row.inspector.last_name &&
                                      row.inspector.last_name)}
                                </TableCell>

                                <TableCell
                                  style={{
                                    padding: "10px",
                                    borderLeft:
                                      language == "ar"
                                        ? "none"
                                        : "1px solid #dadada",
                                    borderRight:
                                      language == "ar"
                                        ? "1px solid #dadada"
                                        : "none",
                                    textAlign:
                                      language == "ar" ? "right" : "left",
                                  }}
                                >
                                  {row.pending_days} day(s)
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow align="center">
                            <TableCell colSpan={6} align="center">
                              <NoRecords />
                            </TableCell>
                          </TableRow>
                        )}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {window.innerWidth <= 500 && (
              <div
                className={classes.container}
                style={{ overflowY: "scroll", width: "100%", padding: "5px" }}
              >
                {rows2.length !== 0 ? (
                  rows2.map((row, index) => {
                    console.log("ROW>>>>>>>>>>>>", row);
                    const isItemSelected = isSelected(row.name);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    console.log(
                      "row.inspection.InspectionReviews[0].user_id",
                      row.inspection.InspectionReviews[0].user_id
                    );
                    console.log("user.id", user);

                    console.log(
                      "currentReviewer____________________________________________________________________________________________________",
                      row
                    );

                    let finalReviewer = "";
                    const A = row.inspection.InspectionReviews;
                    const B = row.inspection.InspectionComments;
                    const finalArray = A.filter(
                      (a) =>
                        !B.map((b) => b.hierarchy_organization_id).includes(
                          a.heirarchy_organization_id
                        )
                    );
                    console.log(
                      finalArray,
                      "LLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL"
                    );
                    finalArray.forEach((item) => {
                      if (item.user_id == user.user_id) {
                        finalReviewer = item.heirarchy_organization_id;
                      }
                    });

                    console.log(
                      "finalReviewer_______________________",
                      finalReviewer
                    );

                    return (
                      <div
                        className="hover shadow"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          border: "1px solid #dadada",
                          padding: "10px",
                          margin: "5px",
                          flexDirection: "row",
                          alignItems: "center",
                          textAlign: "left",
                          height: "220px",
                          borderRadius: "5px",
                          backgroundColor: "white",
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            height: "100%",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <p
                              style={{
                                color: Colors.globalColor8,
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              <>{t("Name")}</>
                            </p>

                            <p
                              style={{
                                fontSize: "12px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              {row.inspection.schedule_title.slice(0, 30) +
                                (row.inspection.schedule_title.length > 30
                                  ? "..."
                                  : "")}
                            </p>
                          </div>
                          <div>
                            <p
                              style={{
                                color: Colors.globalColor8,
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              <>{t("Template")}</>
                            </p>
                            <p
                              style={{
                                fontSize: "12px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              {row.inspection.TemplateInspection.title.slice(
                                0,
                                15
                              ) +
                                (row.inspection.TemplateInspection.title
                                  .length > 15
                                  ? "..."
                                  : "")}
                            </p>
                          </div>

                          <div>
                            <p
                              style={{
                                color: Colors.globalColor8,
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              Inspector{" "}
                            </p>
                            {(row.inspector.first_name &&
                              row.inspector.first_name) +
                              " " +
                              (row.inspector.last_name &&
                                row.inspector.last_name)}
                          </div>
                          <div>
                            <p
                              style={{
                                color: Colors.globalColor8,
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              <>{t("Pending")}</>
                            </p>
                            <p
                              style={{
                                fontSize: "12px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              {row.pending_days} day(s)
                            </p>
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            height: "100%",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <p
                              style={{
                                color: Colors.globalColor8,
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                marginBottom: "0px",
                                marginTop: "0px",
                              }}
                            >
                              {row.score ? row.score : 0}%
                            </p>
                          </div>

                          {row.inspection.isCompleted === true && (
                            <div>
                              <DoneAllIcon style={{ color: "green" }} />
                            </div>
                          )}

                          <div>
                            <img
                              src={pencil}
                              alt="file"
                              width={20}
                              onClick={() =>
                                history.push(
                                  "inspection-edit/" +
                                    row.inspection.id +
                                    "/" +
                                    finalReviewer
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: "250px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <NoRecords />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function OverdueContainer() {
  let { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const [inspections, setInspections] = React.useState([]);
  const [totalInspections, setTotalInspections] = React.useState(0);
  const [chartData, setChartData] = React.useState([]);
  const [inspectionLoader, setInspectionLoader] = React.useState(false);
  const [filter, setFilter] = React.useState("");
  const history = useHistory();
  const [series, setSeries] = React.useState([]);
  const [options, setOption] = React.useState({});

  

  
  async function getOverdueInspections() {
    setInspectionLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let site_obj = {};

    const response = await fetch(
      GlobalApi +
        "/Inspection/over_due_inspections?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id +
        "&count_f=" +
        false,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    console.log(data2,"ppp")
  
    return data2?.data;
  }

      // react-query to fetch data
      const { data, isLoading, isFetching, error, setData } = useQuery(
        "overdueInspections",
        getOverdueInspections,
        {
          enabled: true, // Enable initial data fetching
          refetchOnWindowFocus: false, // Disable automatic refetching on window focus
        }
      );

  const handleFilter = (row, column) => {
    console.log(row, column);
    setFilter(chartData[row + 1][0]);
  };

  // const handleScroll7 = (e) =>{
  //   const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight+10;
  //   if (bottom) {
  //     if(inspections.length < totalInspections){
  //       // getOverdueInspections()

  //     }
  //   }
  // }

  return (
    <div
      variant={"outlined"}
      style={{
        padding: 0,
        backgroundColor: "white",
        height: "350px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "10px",
          display: "flex",
          borderRadius:"5px",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("OverDue/Late Inspections")}</>
        </p>
        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("last 30 days")}</>
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />
      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={0}
          style={{ padding: "5px 20px", backgroundColor: "#eaf7fe" }}
      >
        <Grid
          item
          style={{
            width: "250px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Inspection")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Date")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Score")}</>
          </p>
        </Grid>
      </Grid>

      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />
      <div
        style={{
          overflowY: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "300px",
          borderRadius:'5px',
          padding: "5px",
        }}
      >
        {isLoading ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <div
            className="scrollbarShow2"
            style={{ padding: "10px", overflowY: "scroll" }}
            id="scrollSection7"
            //  onScroll={(e)=>handleScroll7(e)}
          >
            {data.length == 0 && (
              <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "270px",
                }}
              >
                <NoRecords />
              </div>
            )}
            {data.length > 0 &&
              data
                .sort(
                  (a, b) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
                )
                .filter((v) =>
                  filter === "" ? true : filter === v.Schedule?.Site?.title
                )
                .map((v) => {
                  console.log("v>>>>>>>>>>>>>>>>", v);
                  return (
                    <div
                      variant={"outlined"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "20px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: Colors.globalColor4,
                        marginBottom: 5,
                        borderRadius: 5,
                        padding: 0,
                      }}
                      onClick={() =>
                        history.push("inspection-edit/" + v.id + "/view")
                      }
                      className="new-hover"
                    >
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                        spacing={0}
                        style={{ padding: "0px 10px" }}
                      >
                        <Grid
                          item
                          style={{
                            width: "300px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            className="templateName"
                            style={{
                              margin: "2px 0px",
                              textAlign: language === "ar" ? "right" : "left",
                            }}
                          >
                            <Tooltip
                              title={
                                v?.Schedule?.title ? v?.Schedule?.title : " "
                              }
                            >
                              <p>
                                {v?.Schedule?.title.slice(0, 30) +
                                  (v?.Schedule?.title.length > 30 ? "..." : "")}
                              </p>
                            </Tooltip>
                          </p>
                        </Grid>
                        <Grid item>
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            {moment(new Date(v.createdAt)).format(
                              "MMMM DD, YYYY"
                            )}
                          </p>
                        </Grid>
                        <Grid item>
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            {v?.score}
                          </p>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
          </div>
        )}
      </div>
      <Grid
        container
        style={{ display: "flex", justifyContent: "center" }}
        spacing={2}
      >
        <Grid
          item
          xs={12}
          style={{
            padding: 0,
            margin: 10,
            backgroundColor: Colors.backgroundColor,
            maxHeight: window.innerHeight * 0.3,
            overflow: "hidden",
            overflowY: "scroll",
          }}
        />
      </Grid>
    </div>
  );
}

function FailedContainer() {
  let { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let company = useSelector((state) => state.companyReducer.company);
  const [inspections, setInspections] = React.useState([]);
  const [totalInspections, setTotalInspections] = React.useState(0);
  const [chartData, setChartData] = React.useState([]);
  const [inspectionLoader, setInspectionLoader] = React.useState(false);
  const [filter, setFilter] = React.useState("");
  const history = useHistory();
  const [series, setSeries] = React.useState([]);
  const [options, setOption] = React.useState({});

  // React.useEffect(
  //   () => {
  //     getFailedInspections();
  //   },
  //   [company?.id]
  // );

  async function getFailedInspections() {
    setInspectionLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let site_obj = {};

    const response = await fetch(
      GlobalApi +
        "/Inspection/failed_inspections?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id +
        "&count_f=" +
        false,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    console.log(data2,"ppp")
  
    return data2?.data;
  }

      // react-query to fetch data
      const { data, isLoading, isFetching, error, setData } = useQuery(
        "failedInspections",
        getFailedInspections,
        {
          enabled: true, // Enable initial data fetching
          refetchOnWindowFocus: false, // Disable automatic refetching on window focus
        }
      );

  const handleFilter = (row, column) => {
    console.log(row, column);
    setFilter(chartData[row + 1][0]);
  };

  return (
    <div
      variant={"outlined"}
      style={{
        padding: 0,
        backgroundColor: "white",
        height: "350px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "10px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          borderRadius:'5px'
        }}
      >
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Rejected Inspections")}</>
        </p>
        <p
          className="label2"
          style={{
            textAlign: "right",
            display: "inline",
            marginTop: 5,
            fontSize: 10,
            color: "grey",
            textTransform: "capitalized",
          }}
        >
          <>{t("last 30 days")}</>
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={0}
        style={{ padding: "5px 20px", backgroundColor: "#eaf7fe" }}
      >
        <Grid
          item
          style={{
            width: "250px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Inspection")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Date")}</>
          </p>
        </Grid>
        <Grid item>
          <p
            className="templateName"
            style={{
              margin: "2px 0px",
              color: Colors.globalColor8,
              fontWeight: "bold",
              textAlign: language === "ar" ? "right" : "left",
            }}
          >
            <>{t("Score")}</>
          </p>
        </Grid>
      </Grid>

      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />

      <div
        style={{
          overflowY: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "auto",
          padding: "5px",
          borderRadius:'5px',
        }}
      >
        {isLoading ? (
          <div
            style={{
              height: "300px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <div
            className="scrollbarShow2"
            style={{ padding: "10px", overflowY: "scroll" }}
            id="scrollSection8"
            //  onScroll={(e)=>handleScroll8(e)}
          >
            {data.length == 0 && (
              <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height:"270px"
                }}
              >
                <NoRecords />
              </div>
            )}
            {data.length > 0 &&
              data
                .sort(
                  (a, b) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
                )
                .filter((v) =>
                  filter === "" ? true : filter === v.Schedule?.Site?.title
                )
                .map((v) => {
                  console.log("v>>>>>>>>>>>>>>>>", v);
                  let localstorage = localStorage.getItem("UserData");
                  var user = JSON.parse(localstorage);
                  return (
                    <div
                      variant={"outlined"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "20px",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: Colors.globalColor4,
                        marginBottom: 5,
                        borderRadius: 5,
                        padding: 0,
                      }}
                      onClick={() =>
                        history.push("inspection-edit/" + v.id + "/view")
                      }
                      className="new-hover"
                    >
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                        spacing={0}
                        style={{ padding: "0px 10px" }}
                      >
                        <Grid
                          item
                          style={{
                            width: "300px",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <p
                            className="templateName"
                            style={{
                              margin: "2px 0px",
                              textAlign: language === "ar" ? "right" : "left",
                            }}
                          >
                            <Tooltip
                              title={
                                v?.Schedule?.title ? v?.Schedule?.title : " "
                              }
                            >
                              <p>
                                {v?.Schedule?.title.slice(0, 30) +
                                  (v?.Schedule?.title.length > 30 ? "..." : "")}
                              </p>
                            </Tooltip>
                          </p>
                        </Grid>
                        <Grid item>
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            {moment(new Date(v.createdAt)).format(
                              "MMMM DD, YYYY"
                            )}
                          </p>
                        </Grid>
                        <Grid item>
                          <p
                            className="templateName"
                            style={{ margin: "2px 0px" }}
                          >
                            {v?.score}
                          </p>
                        </Grid>
                      </Grid>
                    </div>
                  );
                })}
          </div>
        )}
      </div>
      <Grid
        container
        style={{ display: "flex", justifyContent: "center" }}
        spacing={2}
      >
        <Grid
          item
          xs={12}
          style={{
            padding: 0,
            margin: 10,
            backgroundColor: Colors.backgroundColor,
            maxHeight: window.innerHeight * 0.3,
            overflow: "hidden",
            overflowY: "scroll",
          }}
        />
      </Grid>
    </div>
  );
}

function TodoContainer({ getPackageDetails }) {
  let language = useSelector((state) => state.languageReducer.language);
  let { t } = useTranslation();
  const history = useHistory();
  // const [schedules, setSchedules] = React.useState([]);
  // const [toDoLoader, setToDoLoader] = React.useState(false);
  const [totalSchedules, setTotalSchedules] = React.useState(0);
  // const [packageDetails, setPackageDetails] = React.useState(null);

  let company = useSelector((state) => state.companyReducer.company);

  function handleStart(schedule_id, template_id) {
    console.log(schedule_id, template_id);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      schedule_id,
      template_id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(
      GlobalApi + "/TemplateInspection/get_template_for_inspection?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          if (response.data) {
            createInspection(response.data);

            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            handleStart(schedule_id, template_id);
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  }

  const getSchedules = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    const response = await fetch(
      GlobalApi +
        "/ScheduleAssignee/get_schedule_daily?user_id=" +
        data?.user_id +
        "&company_id=" +
        company?.id,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );
    const data2 = await response.json();
    if (data2.status == "Success") {
      setTotalSchedules(data2?.total_records);
      return data2;
    } else if (
      data2.error === "jwt expired" ||
      data2.error === "invalid token" ||
      data2.error === "invalid signature" ||
      data2.error === "Unexpected token"
    ) {
      let status = await refresh_token();
      if (status) {
        getSchedules();
      }
    }
  };

  async function createInspection({ id, schedule_id }) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let inspection_obj = {
      schedule_id,
      template_id: id,
      user_id: data.user_id,
      company_id: company?.id,
      created_by: data.user_id,
    };

    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

    if (reqJson.package.inspection_request_status === "Request is Valid") {
      fetch(GlobalApi + "/Inspection/create_inspection", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(inspection_obj),
      })
        .then((response) => response.json())
        .then(async (res1) => {
          console.log(res1);
          fetch(GlobalApi + "/InspectionShare/create_inspection_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              inspection_id: res1.data.id,
              user_id: data.user_id,
              created_by: data.user_id,
              role: "Owner",
              isEditor: true,
              isOwner: true,
            }),
          })
            .then((response) => response.json())
            .then(async (res) => {
              console.log(res);
              history.push("inspection-edit/" + res1.data.id + "/edit");
            });
        });
    } else {
      swal(t("Warning"), reqJson.package.inspection_request_status, "warning");
    }
  }

  React.useEffect(
    () => {
      getSchedules();
    },
    [company?.id]
  );

  React.useEffect(() => {
    getPackageDetails();
  }, []);

  const { data: schedules, isLoading: toDoLoader } = useQuery(
    "schedules",
    getSchedules
  );

  console.log("schedules", schedules);

  // if (packageDetails !== null) {
  return (
    <div
      variant={"outlined"}
      style={{
        padding: 0,
        margin: 0,
        backgroundColor: "white",
        height: "350px",
        borderRadius:"5px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ padding: "10px" }}>
        <p
          className="label2"
          style={{
            marginTop: 0,
            fontSize: 14,
            textAlign: language === "ar" ? "right" : "left",
            color: Colors.globalColor8,
            textTransform: "uppercase",
          }}
        >
          {" "}
          <>{t("Today's Inspections")}</>
        </p>
      </div>
      <hr
        style={{
          borderTop: "1px solid #e5ecef",
          borderBottom: "none",
          marginTop: 0,
          width: "100%",
          marginBottom: 0,
        }}
      />
      <div
        style={{
          padding: "2px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {toDoLoader ? (
          <div
            style={{
              height: "290px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <div
            className="scrollbarShow2"
            style={{
              height: "300px",
              padding: "5px",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            {schedules?.data.length == 0 && (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <NoRecords />
              </div>
            )}
            {schedules?.data.length > 0 &&
              schedules?.data?.map((sche) => {
                return (
                  <div
                    variant={"outlined"}
                    style={{
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: Colors.globalColor4,
                      padding: 0,
                      margin: "5px 2px",
                      borderRadius: 5,
                      padding: 0,
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Grid
                      className="hover"
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      style={{
                        padding: 5,
                        margin: 0,
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <Grid
                        item
                        justify="center"
                        style={{
                          padding: 0,
                          margin: 0,
                          maxWidth: "140px",
                          overflow: "hidden",
                          display: "flex",
                          flexWrap: "nowrap",
                        }}
                      >
                        <p
                          className="templateName"
                          style={{ margin: "2px 0px" }}
                        >
                          {sche.title.slice(0, 15) +
                            (sche.title.length > 15 ? "..." : "")}
                        </p>
                      </Grid>
                      <Grid item align="right">
                        <DarkButton
                          onClick={() => handleStart(sche.id, sche.template_id)}
                          size="small"
                          style={{
                            fontSize: 10,
                            paddingLeft: 0,
                            paddingRight: 0,
                            backgroundColor: Colors.globalColor8,
                          }}
                        >
                          <>{t("Start Now")}</>
                        </DarkButton>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
  // } else {
  //   return <Spinner />;
  // }
}


